<label
  [class.checked]="input.checked"
  [class.left-side]="labelOnLeftSide"
  [class.error]="controlDir?.invalid && parentFormGroup.submitted"
>
  <div class="mark"></div>
  <input type="radio" [name]="name" [value]="value" #input />
  <span>
    <ng-content></ng-content>
  </span>
</label>
